import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/LanguageContext';
import './Services.css';

function Services() {
  const { language } = useLanguage();

  const content = {
    en: {
      tag: 'Our Services',
      title: 'What We Offer',
      services: [
        {
          img: require("../Images/1.jpeg"),
          title: "General Cleaning",
          description: "Complete cleaning for doors, windows, and all facilities.",
          button: "Book Now"
        },
        {
          img: require("../Images/2.jpeg"),
          title: "Upholstery Care",
          description: "Premium cleaning for furniture, carpets, curtains, and beddings.",
          button: "Book Now"
        },
        {
          img: require("../Images/3.jpeg"),
          title: "Facade Cleaning",
          description: "Specialized services for glass facades and exterior surfaces.",
          button: "Book Now"
        },
        {
          img: require("../Images/4.jpeg"),
          title: "Sanitization",
          description: "Safe sterilization with premium fragrances for your comfort.",
          button: "Book Now"
        }
      ]
    },
    ar: {
      tag: 'خدماتنا',
      title: 'ماذا نقدم',
      services: [
        {
          img: require("../Images/1.jpeg"),
          title: "تنظيف عام",
          description: "تنظيف شامل للأبواب والنوافذ وجميع المرافق.",
          button: "احجز الآن"
        },
        {
          img: require("../Images/2.jpeg"),
          title: "عناية بالمفروشات",
          description: "تنظيف فاخر للأثاث والسجاد والستائر والمفارش.",
          button: "احجز الآن"
        },
        {
          img: require("../Images/3.jpeg"),
          title: "تنظيف الواجهات",
          description: "خدمات متخصصة للواجهات الزجاجية والأسطح الخارجية.",
          button: "احجز الآن"
        },
        {
          img: require("../Images/4.jpeg"),
          title: "التعقيم والتعطير",
          description: "تعقيم آمن مع عطور فاخرة لراحتك.",
          button: "احجز الآن"
        }
      ]
    }
  };

  const { tag, title, services } = content[language];

  return (
    <section id="services" className={`services ${language === 'ar' ? 'rtl' : ''}`}>
      <div className="services-container">
        {/* Header */}
        <motion.div 
          className="services-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="services-tag">{tag}</span>
          <h2 className="services-title">{title}</h2>
        </motion.div>

        {/* Grid */}
        <div className="services-grid">
          {services.map((service, i) => (
            <motion.article
              key={i}
              className="service-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              {/* Image */}
              <div className="service-image">
                <img src={service.img} alt={service.title} />
                <span className="service-number">0{i + 1}</span>
              </div>

              {/* Content */}
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>

              {/* CTA */}
              <a
                href="https://wa.me/966560308877"
                target="_blank"
                rel="noopener noreferrer"
                className="service-cta"
              >
                <i className="fab fa-whatsapp" />
                {service.button}
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
